import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackException, trackUnhandledRejection } from '../utils/gaEvents';

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
      page_path: location?.pathname + location?.search,
      page_title: document.title,
    });
  }, [location]);

  useEffect(() => {
    const handleError = (event) => {
      const message = event?.message || 'Unknown error';
      const source = event?.filename || event?.error?.stack?.split('\n')?.[1]?.trim() || 'unknown';
      trackException(message, false, source);
    };

    const handleUnhandledRejection = (event) => {
      const reason =
        event?.reason?.message ||
        (typeof event?.reason === 'string' ? event?.reason : null) ||
        'Unhandled promise rejection';
      trackUnhandledRejection(reason);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);
}
